import 'react-dates/initialize';
import React, { Component } from 'react';
import 'react-dates/lib/css/_datepicker.css';
import moment from '../utils/momentTimeZone';
import SelectRefinement from './SelectRefinement';
import DateRefinement from './DateRefinement';

class FilterBy extends Component {

    constructor(props) {
        super(props)
        this.state = {
            startDate: moment(),
            endDate: null,
            focusedInput: null
        }
    }

    render() {
        return (
            <div className="c-whats-on--filterby">
                {false && <DateRefinement
                    attribute="postDate"
                    items={[{label: 'date', start: this.startDate, end: this.endDate}]}
                />}
                <div className="c-event-filter c-event-filter__event">
                    <SelectRefinement operator="or" attribute="eventTypes" placeholder="Event Type" />
                </div>

                <div className="c-event-filter c-event-filter__venue">
                    <SelectRefinement operator="or" attribute="venues" placeholder="Venue" />
                </div>
                <div className="c-event-filter c-event-filter__access">
                    <SelectRefinement operator="or" attribute="access" placeholder="Access Type" />
                </div>
            </div>
        );
    }
}

export default FilterBy;



// WEBPACK FOOTER //
// ./src/whatson/components/FilterBy.js